import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from '@environments/environment';
import { hmrBootstrap } from './hmr';
import 'hammerjs';
import { isolateSessionForLegacyHandshake } from '@core/utils/session-isolation.util';

if (environment.baseUrl.indexOf('intergrip.test') === -1) {
  Sentry.init({
    dsn: "https://03ac9342af45bb80e91b2cfd26f45dd0@o4507106811379712.ingest.de.sentry.io/4507107672260688",
    environment: setEnvName(environment.name),
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration(),
    ],
    tracePropagationTargets: ['localhost', 'https://portaal.intergrip.nl/'],
    tracesSampleRate: 0.002,
  });
}

if (environment.production) {
  enableProdMode();
}

isolateSessionForLegacyHandshake(window.location.search);

const bootstrap = () =>
  platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] });

if (environment.hmr) {
  if ((module as unknown as any).hot) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
  }
} else {
  bootstrap().catch(err => console.error(err));
}

function setEnvName(env: string): string {
  switch (env.toLowerCase()) {
    case 'test':
    case 'production':
    case 'acceptance':
      return env;
    default:
      return 'production';
  }
}
